// Consistent colors for companies based on their brand colors
export const COMPANY_COLORS: Record<string, string> = {
  // Tech Giants
  'AAPL': '#A2AAAD', // Apple gray
  'MSFT': '#00A4EF', // Microsoft blue
  'GOOGL': '#4285F4', // Google blue
  'GOOG': '#4285F4', // Google blue
  'AMZN': '#FF9900', // Amazon orange
  'META': '#0668E1', // Meta blue
  'NVDA': '#76B900', // NVIDIA green
  'TSLA': '#E82127', // Tesla red
  'AVGO': '#E4002B', // Broadcom red
  'ORCL': '#F80000', // Oracle red
  'ADBE': '#FF0000', // Adobe red
  'CRM': '#00A1E0', // Salesforce blue
  'INTC': '#0071C5', // Intel blue
  'AMD': '#ED1C24', // AMD red
  'NFLX': '#E50914', // Netflix red
  
  // ETFs
  'SPY': '#1E3A8A', // Dark blue
  'QQQ': '#059669', // Green
  'VOO': '#7C3AED', // Purple
  'VTI': '#DC2626', // Red
  'IVV': '#2563EB', // Blue
  'VEA': '#EA580C', // Orange
  'VWO': '#16A34A', // Green
  'AGG': '#6366F1', // Indigo
  
  // Financial
  'JPM': '#0070CD', // JPMorgan blue
  'BAC': '#E31837', // BofA red
  'WFC': '#D71E28', // Wells Fargo red
  'GS': '#5C9DD5', // Goldman blue
  'MS': '#00A1DF', // Morgan Stanley blue
  'V': '#1A1F71', // Visa blue
  'MA': '#EB001B', // Mastercard red
  'BRK.B': '#003087', // Berkshire blue
  
  // Healthcare
  'UNH': '#002677', // UnitedHealth blue
  'JNJ': '#D51317', // J&J red
  'LLY': '#CC0000', // Lilly red
  'PFE': '#0093D0', // Pfizer blue
  'ABBV': '#071D49', // AbbVie dark blue
  'TMO': '#0D4C92', // Thermo Fisher blue
  'MRK': '#0097D8', // Merck blue
  
  // Consumer
  'WMT': '#0071CE', // Walmart blue
  'HD': '#F96302', // Home Depot orange
  'PG': '#003DA5', // P&G blue
  'KO': '#F40009', // Coca-Cola red
  'PEP': '#004B93', // Pepsi blue
  'COST': '#0074A8', // Costco blue
  'NKE': '#111111', // Nike black
  'MCD': '#FFC72C', // McDonald's yellow
  
  // Industrial
  'BA': '#0033A1', // Boeing blue
  'CAT': '#FFCD11', // Caterpillar yellow
  'GE': '#0075C9', // GE blue
  'MMM': '#FF0000', // 3M red
  
  // Energy
  'XOM': '#FF0000', // Exxon red
  'CVX': '#003DA5', // Chevron blue
  
  // Telecom
  'T': '#009FDB', // AT&T blue
  'VZ': '#CD040B', // Verizon red
  
  // Other
  'DIS': '#113CCF', // Disney blue
  'FTNT': '#EE3124', // Fortinet red
  'NET': '#F38020', // Cloudflare orange
};

// Fallback colors for companies not in the list
const FALLBACK_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
  '#ec4899', '#14b8a6', '#f97316', '#06b6d4', '#6366f1',
  '#84cc16', '#f43f5e', '#8b5cf6', '#0ea5e9', '#22c55e',
];

export function getCompanyColor(symbol: string, index: number = 0): string {
  return COMPANY_COLORS[symbol] || FALLBACK_COLORS[index % FALLBACK_COLORS.length];
}

// Get all colors for a list of symbols
export function getCompanyColors(symbols: string[]): string[] {
  return symbols.map((symbol, index) => getCompanyColor(symbol, index));
}
